import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

/* eslint-disable react/forbid-prop-types */

const ItemReactLink = ({ item, className = "", onClick = () => {} }) => (
  <Link to={item.relative} className={className} onClick={onClick}>
    {item.title}
  </Link>
);

ItemReactLink.propTypes = {
  item: PropTypes.any.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};

ItemReactLink.defaultProps = {
  className: "",
  onClick: () => {}
};

export default ItemReactLink;
